import { gql } from '@apollo/client';

import assetFields from './assetFields';

const listingFields = gql`
  ${assetFields}
  fragment ListingField on Listing {
    id
    listingId
    quantity
    type
    asset {
      ...AssetField
    }
    status
    seller {
      id
      address
    }
    # starsPrice
    # ethPrice
    # isStarsListing
    # isEthListing
    listingPrices {
      id
      listingToken
      price
    }
    startTime
    endTime
    highestBidAmount
    highestBidToken
    highestBidder {
      id
      address
    }
  }
`;

export default listingFields;
